import { useEffect, useState } from "react";

/* a custom React Hook function to respond to changes in page width */
export const usePageWidth = () => {
    const [pageWidth, setPageWidth] = useState(window.innerWidth);
    useEffect(() => {
        const onWindowResize = () => {
            setPageWidth(window.innerWidth);
        }
        window.addEventListener('resize', onWindowResize);
        return () => {
            /* clean up event listener */
            window.removeEventListener('resize', onWindowResize);
        }
    }, []);
    return { pageWidth };
}
